import * as React from 'react';
import {RouteComponentProps} from 'react-router';
import {Container, Flag,Image, Message, Form, Grid, Segment, Button, Transition} from 'semantic-ui-react';
import i18n from "../../../../locale/i18n";
import axios, {AxiosError} from 'axios';
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";

const logo = require('../../logo.svg');
const translator = i18n.t.bind(i18n);

type OnboardingContainerState = {
  currentStep: number;

  hasError: boolean;
  errorMsg: string;

  userId: string;
  password: string;

  submitting: boolean;

  finalStepText: string;
  finalStepTextParam: string;
}

const STEP_START = 0;
const STEP_LOGINFORM = 1;
const STEP_FINISHED = 2;

class OnboardingContainer extends React.Component<RouteComponentProps<{}>, OnboardingContainerState> {

  constructor(props: Readonly<RouteComponentProps<{}>>) {
    super(props);
    this.state = {
      currentStep: 0,

      hasError: false,
      errorMsg: '',

      userId: '',
      password: '',

      submitting: false,

      finalStepText: '',
      finalStepTextParam: ''
    };
  }

  nextStep() {
    this.setState({
      currentStep: this.state.currentStep + 1
    });
  }

  previousStep() {
    this.setState({
      currentStep: this.state.currentStep - 1
    });
  }

  componentDidMount(): void {
  }


  onChangeLanguage(language : string) {
    i18n.changeLanguage(language);
    this.forceUpdate();
  }

  submitLogin() {
    this.setState({submitting: true, hasError: false, errorMsg: ''},
        () => {
          axios.post('./migration', {
            userId: this.state.userId,
            password: this.state.password
          }).then(response => {
            const responseData = response.data;
            let text = '';
            if(responseData.status === 'success') {
              text = 'Onboarding.StepFinal_Success%s';
            } else if(responseData.status === 'already_migrated') {
              text = 'Onboarding.StepFinal_AlreadyMigrated';
            } else if(responseData.status === 'no_email') {
              text = 'Onboarding.StepFinal_NoEmail';
            }
            this.setState({
              submitting: false,
              hasError: false,
              finalStepText: text,
              finalStepTextParam: responseData.email || '',
              currentStep: STEP_FINISHED
            })
          }).catch((error: AxiosError) => {
            let errorMsg = 'Onboarding.Error_Unknown';
            if(error.response && error.response.status === 401) {
              errorMsg = 'Onboarding.Error_InvalidCredentials';
            }
            this.setState({
              submitting: false,
              hasError: true,
              errorMsg: errorMsg
            });
          });
        });
  }

  renderStep() {
    switch(this.state.currentStep) {
      case STEP_START:
        return (
          <Segment textAlign={"center"}>
            <Button fluid onClick={() => this.nextStep()}>{translator('Onboarding.BtnMigrate')}</Button>
            <span style={{width: '100%!important', textAlign:'center', display: 'block', padding: '1em', fontWeight: 'bold'}}>{translator('Onboarding.BtnDividerOr')}</span>
            <Button fluid onClick={() => this.props.history.push('/')}>{translator("Onboarding.BtnAlreadyMigrated")}</Button>
          </Segment>
        );
      case STEP_LOGINFORM:
        return (
            <Segment>
              <h3>{translator('Onboarding.StepLogin_Header')}</h3>
              {translator('Onboarding.StepLogin_Info')}<br /><br />
              <Form loading={this.state.submitting} error={this.state.hasError}  onSubmit={() => this.submitLogin()}>
                <Message
                    error={true}
                    icon="warning"
                    header={translator("Login.Form.LoginFailed")}
                    content={translator(this.state.errorMsg)}
                />
                <Form.Input
                    label={translator("Login.Form.UserID")}
                    icon="user"
                    name="userId"
                    type="string"
                    required={true}
                    value={this.state.userId}
                    onChange={(_,data) => this.setState({userId: data.value})}
                />
                <Form.Input
                    label={translator("Login.Form.Password")}
                    icon="key"
                    name="password"
                    type="password"
                    required={true}
                    value={this.state.password}
                    onChange={(_,data) => this.setState({password: data.value})}
                />
                <Grid columns="2">
                  <Grid.Column><Button type="button" basic onClick={() => this.previousStep()}>{translator("Onboarding.Back")}</Button></Grid.Column>
                  <Grid.Column textAlign="right">
                    <Form.Button type="submit" content={translator("Login.Form.Login")}/>
                  </Grid.Column>
                </Grid>
              </Form>
            </Segment>
        );
      case STEP_FINISHED:
        return (<Segment>
              <h3>{translator('Onboarding.StepFinal_Header')}</h3>
              {translator(this.state.finalStepText, {mail: this.state.finalStepTextParam})}
            </Segment>
        );
      default:
        throw new Error('Invalid Step');
    }
  }

  render() {
    return (
        <Grid centered={true} verticalAlign="middle" className={"login-grid"}>

          <AnalyticsTracking page="onboarding" />
          <Grid.Row divided={true}>
            <Grid.Column widescreen="4" mobile="15" tablet="7" computer="5" largeScreen="4">
              <Image src={logo} alt="Landgard Logo" spaced={false} size="medium" centered={true}/>
              <h2 className={"loginHeading"}> {translator("Onboarding.Header")}</h2>

              <Container textAlign='left'>
                <br/>
                {translator("Onboarding.ContactInfo")}
                <ul>
                  <li>{translator("Login.ListItem1")} +49 2832 921-3110</li>
                  <li>{translator("Login.ListItem2")} stammdaten@landgard.de</li>
                </ul>

                {translator("Login.Text3")}

              </Container>
            </Grid.Column>
            <Grid.Column widescreen="3" mobile="15" tablet="7" computer="5" largeScreen="4">
              <Flag name={"de"} className={"languageChangeFlag"} onClick={()=> {this.onChangeLanguage("de")}}/>
              <Flag name={"gb"} className={"languageChangeFlag"} onClick={()=> {this.onChangeLanguage("en")}}/>
              <Flag name={"nl"} className={"languageChangeFlag"} onClick={()=> {this.onChangeLanguage("nl")}}/>
              <Transition.Group animation="browse">
                {this.renderStep()}
              </Transition.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>
    );
  }
}

export default OnboardingContainer;